export default __webpack_public_path__ + "static/media/Comp 2_00004.55c907f8.png";